export { default } from './RatingsInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/RatingsInfo/index.js